import { useEffect, useRef, useState } from 'react'

import { getSeenCompanyIds, markCompanyAsSeen } from '../util/seenReferralTooltipCompanies'

let currentlyShownCompanyId: string | null = null

interface Params {
  referralCode: string | undefined
  companyId: string | undefined
  isCustomer: boolean
}

// Shows the tooltip once per company — only the first time a customer opens the venue profile.
const useReferralTooltipOnFirstVisit = ({ referralCode, companyId, isCustomer }: Params) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)
  // Read localStorage once at mount, not on every effect re-run.
  const seenIdsAtMount = useRef(getSeenCompanyIds())

  useEffect(() => {
    if (!companyId || !isCustomer || referralCode) return
    if (currentlyShownCompanyId === companyId) return

    if (seenIdsAtMount.current.includes(companyId)) return

    currentlyShownCompanyId = companyId
    markCompanyAsSeen(companyId)
    setIsTooltipOpen(true)

    return () => {
      currentlyShownCompanyId = null
    }
  }, [companyId, isCustomer])

  const closeTooltip = () => setIsTooltipOpen(false)

  return { isTooltipOpen, closeTooltip }
}

export default useReferralTooltipOnFirstVisit
